<template>
  <div class="flex h-full flex-col items-stretch">
    <div class="mx-8 mb-4 mt-10 flex items-center justify-between">
      <button
        class="flex items-center gap-2"
        @click="emit('go-back')"
      >
        <IconArrowRight class="size-8 rotate-180 md:hidden" />
        <h2 class="block text-2xl font-medium leading-none">Уведомления</h2>
      </button>
    </div>

    <div class="mx-4 h-px bg-black opacity-10"></div>

    <div class="relative my-2 h-0 grow">
      <div class="absolute top-0 z-10 h-8 w-full bg-gradient-to-b from-whitegray to-transparent"></div>
      <div class="absolute bottom-0 z-10 h-8 w-full bg-gradient-to-t from-whitegray to-transparent"></div>
      <form
        class="h-full overflow-y-scroll px-8 py-8 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray flex flex-col items-stretch scroll-smooth"
        @submit="onSubmit"
      >
        <div class="mb-16">
          <h2 class="mb-4 text-xl font-medium text-black">О статусе заказа</h2>

          <HeadlessSwitchGroup
            as="div"
            class="flex items-center justify-between border-y border-black border-opacity-10 py-4"
          >
            <HeadlessSwitchLabel>Пуши (все устройства)</HeadlessSwitchLabel>
            <InputSwitch name="order_push" v-model="notifications.order_status.push" />
          </HeadlessSwitchGroup>

            <SimpleButton v-if="showRequestPermissionButton" class="my-4 w-full px-8 py-5 font-bold uppercase text-sm" type="button" @click="requestPermission">Разрешить пуш-уведомления для текущего устройства</SimpleButton>
        </div>

          <!--
                 <div>
                   <h2 class="mb-4 text-xl font-medium text-black">Об акциях и скидках</h2>

                   <HeadlessSwitchGroup
                     as="div"
                     class="flex items-center justify-between border-y border-black border-opacity-10 py-4"
                   >
                     <HeadlessSwitchLabel>Пуши</HeadlessSwitchLabel>
                     <InputSwitch name="get_pushes" />
                   </HeadlessSwitchGroup>

                   <HeadlessSwitchGroup
                     as="div"
                     class="flex items-center justify-between border-b border-black border-opacity-10 py-4"
                   >
                     <HeadlessSwitchLabel>Письмо на почту</HeadlessSwitchLabel>
                     <InputSwitch name="email_pushes" />
                   </HeadlessSwitchGroup>
                   <HeadlessSwitchGroup
                     as="div"
                     class="flex items-center justify-between border-b border-black border-opacity-10 py-4"
                   >
                     <HeadlessSwitchLabel>Смс</HeadlessSwitchLabel>
                     <InputSwitch name="sms_pushes" />
                   </HeadlessSwitchGroup>

        </div>
-->
          <div class="flex-1"></div>
          <SimpleButton class="px-8 py-5 text-sm font-medium uppercase" type="submit">Сохранить</SimpleButton>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as yup from 'yup'
import { getMessaging, getToken } from 'firebase/messaging'
import MyToastError from '~/components/MyToastError.vue'
import { useToast } from 'vue-toastification'
import { DateTime } from 'luxon'
import MyToast from '~/components/MyToast.vue'
import { useSetUser, useSetUserNotifications } from '~/composables/api/user'
import type { UserNotifications } from '~/interfaces/users'
import { ref } from 'vue'
const emit = defineEmits(['go-back'])

const notifications = ref<UserNotifications>()
const { data: usersSettings } = useUser((r) =>  {
    notifications.value = r.notifications
    return r.notifications
})

const { mutate: setUser } = useSetUser()

const toast = useToast()
const { $FCMRequestPermission } = useNuxtApp()

const requestPermission = async () => {
    let result
    if(Notification) {
        result = await Notification.requestPermission()
    }

    $FCMRequestPermission(result == "granted").then((result) => {
        showRequestPermissionButton.value = false
    }).catch((err) => {
        showRequestPermissionButton.value = true
        toast({
                component: MyToastError,
                props: {
                    title: 'Ошибка',
                    detail: err,
                }
            },
            {
                timeout: 6000
            })

        /*if(notificationsValues) {
            notificationsValues.order_status.push = false
            notifications.value  = notificationsValues
        }*/
    })
};
const showRequestPermissionButton = ref(false)
/*
$FCMRequestPermission().then((result) => {

}).catch((err) => {
    showRequestPermissionButton.value = true
})*/


const { mutate } = useSetUserNotifications()

const pushesEnabled = ref(false)
watch(notifications, (notificationsValues) => {
    let isEnabled = notificationsValues?.order_status.push
    if(isEnabled) {
        if(Notification.permission == "granted") {
            $FCMRequestPermission(true)
        } else {
            showRequestPermissionButton.value = true
        }
    } else {
        showRequestPermissionButton.value = false
    }

    if(isEnabled !== null && notificationsValues) {
        mutate(notificationsValues)
    }
}, {deep: true, immediate: true})

const { values, handleSubmit } = useForm<any>({
  validationSchema: yup.object({
    order_push: yup.boolean().label('Пуши о статусе заказа'),
  }),
  initialValues: usersSettings,
})

const onSubmit = handleSubmit((vals) => {
    if(notifications.value) {
        mutate(notifications.value, {
            onSuccess: () => {
                toast({
                    component: MyToast,
                    props: {
                        title: 'Настройки сохранены',
                        detail: 'Настройки уведомлений были успешно изменены',
                    },
                })
            }
        })
    }
})

onBeforeUnmount(() => {
  setUser({
    ...values,
  })
})
</script>
